module.exports = __webpack_public_path__ + "img/placeholder_girl_1x.3eb01e2c.png";